const ACCESS_TOKEN_KEY = 'token';
const INVALID_TOKEN_VALUES = new Set(['undefined', 'null',]);

export const normalizeAccessToken = (token: unknown): string | null => {
  if (typeof token !== 'string') {
    return null;
  }

  const normalizedToken = token.trim();

  if (
    !normalizedToken
    || INVALID_TOKEN_VALUES.has(normalizedToken.toLowerCase())
  ) {
    return null;
  }

  return normalizedToken;
};

export const readAccessToken = (): string | null => {
  try {
    const storedToken = window.localStorage.getItem(ACCESS_TOKEN_KEY);
    const normalizedToken = normalizeAccessToken(storedToken);

    if (storedToken !== null && !normalizedToken) {
      window.localStorage.removeItem(ACCESS_TOKEN_KEY);
    }

    return normalizedToken;
  } catch {
    return null;
  }
};

export const writeAccessToken = (token: unknown): string | null => {
  const normalizedToken = normalizeAccessToken(token);

  if (!normalizedToken) {
    return null;
  }

  try {
    window.localStorage.setItem(ACCESS_TOKEN_KEY, normalizedToken);
    return normalizedToken;
  } catch {
    return null;
  }
};
